<template>
  <section>
    <!--工具条-->
    <el-table :data="tableData" border v-loading="listLoading">
      <el-table-column
        prop="spec_name"
        label="规格">
      </el-table-column>
      <el-table-column
        prop="market_price"
        label="市场价">
      </el-table-column>
      <el-table-column
        prop="cpprice"
        label="宠品价">
      </el-table-column>
       <el-table-column
        prop="cost"
        label="成本价">
      </el-table-column>
      <el-table-column
        prop="inventory"
        label="库存">
      </el-table-column>
      <el-table-column
        prop="is_default"
        label="是否默认">
        <template scope="scope">
          <div>{{isDefault[scope.row.is_default]}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button size="small" type="primary"  @click="editHandler(scope.row)">修改</el-button>
          <el-button size="small" type="primary"  @click="deleteHandler(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
    <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="商品规格" prop="spec_name">
          <el-select v-model="editForm.spec_name" placeholder="请选择">
            <el-option
              v-for="item in prospecArr"
              :key="item.label"
              :label="item.label"
              :value="item.label"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市场价" prop="market_price">
          <el-input v-model="editForm.market_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="宠品价" prop="cpprice">
          <el-input v-model="editForm.cpprice" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="成本价" prop="cost">
          <el-input v-model="editForm.cost" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="库存" prop="inventory">
          <el-input v-model="editForm.inventory" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="是否默认" prop="is_default">
          <el-switch
            v-model="editForm.is_default"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        listLoading: false,
        query: '',
        submitLoading: false,
        editFormVisible: false,
        editForm: {},
        formRules: {},
        isDefault: basicdata.isDefault,
        prospecArr: [],
        proid: 0,
      }
    },
    methods: {
      search() {
        this.listLoading = true;
        this.$axios.get(config.api_url + '/product/specification/' + this.proid, 
        ).then(response => {
          let data = response.data;
          if (data.state) {
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //操作删除
      deleteHandler(id) {
        if (id != 0) {
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/product/specification/' + id
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '删除规格失败',
                type: 'warning'
              });
            }
            this.search();
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '删除规格异常',
              type: 'error'
            });
          });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row;
        this.editForm.is_default = row.is_default.toString();
      },
      //修改提交
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              para.is_default = parseInt(para.is_default);
              para.inventory = parseInt(para.inventory);
              para.cpprice = parseFloat(para.cpprice);
              para.cost = parseFloat(para.cost);
              para.market_price = parseFloat(para.market_price);
              let paras = [para];
              //异步请求
              this.$axios.put(config.api_url + '/product/specification',
                paras).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      //获取规格列表
      getSpec() {
        this.$axios.get(config.api_url + '/specification/list'
        ).then(response => {
          for(const item of response.data.msg) {
            this.prospecArr.push({
              label: item.name,
              value: item.id
            })
          }
        }).catch(error => {
          console.log(error)
        });
      },
    },
    created() {
      this.proid = parseInt(this.$route.params.proid);
      this.search();
      this.getSpec();
    }
  }
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// prospec.vue?3ac068a0